import React from "react";
import GetVatTypeName from "../../functions/utils/getVatTypeName";
import moneyFormat from "../../functions/utils/moneyFormat";

const InvoiceDescription = ({ data }) => {
  const hasVat = data.invoiceItems?.find((item) => item.invoiceItemVatInfo);
  const vatInfo = hasVat ? hasVat.invoiceItemVatInfo : null;
  const fee = parseFloat(data.feeAmount) || 0;
  const payTotal =
    data.totalAmount != null && data.totalAmount !== ""
      ? parseFloat(data.totalAmount)
      : parseFloat(data.amount) + fee;

  return (
    <section className="invoice-pay-summary" aria-label="Төлбөрийн дэлгэрэнгүй">
      <div className="invoice-pay-summary__accent" aria-hidden />
      <div className="invoice-pay-summary__body">
        <div className="invoice-pay-summary__meta">
          <span className="invoice-pay-summary__eyebrow">Төлбөр</span>
          {data.id != null && (
            <span className="invoice-pay-summary__id">#{data.id}</span>
          )}
        </div>

        <h1 className="invoice-pay-summary__title">{data.description}</h1>

        <div className="invoice-pay-summary__amount-block">
          <p className="invoice-pay-summary__amount-label">Төлөх дүн</p>
          <p className="invoice-pay-summary__amount">
            {moneyFormat(payTotal)}
            <span className="invoice-pay-summary__currency">₮</span>
          </p>
          {fee > 0 ? (
            <p className="invoice-pay-summary__fee-detail">
              <span>Үндсэн дүн {moneyFormat(data.amount)}₮</span>
              <span className="invoice-pay-summary__fee-dot" aria-hidden>
                ·
              </span>
              <span>Шимтгэл {moneyFormat(fee)}₮</span>
            </p>
          ) : (
            <p className="invoice-pay-summary__fee-detail">Шимтгэлгүй</p>
          )}
        </div>

        {hasVat && (
          <div className="invoice-pay-summary__vat">
            <div className="invoice-pay-summary__vat-row">
              <span>НӨАТ-ын баримт</span>
              <span>{GetVatTypeName(vatInfo.type)}</span>
            </div>
            {vatInfo.easyRegister && (
              <div className="invoice-pay-summary__vat-row">
                <span>Хялбар бүртгэл</span>
                <span>{vatInfo.easyRegister}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default InvoiceDescription;
